/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStarEmpty: {
  name: 'star-empty';
  data: string;
} = {
  name: 'star-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a1 1 0 0 1 .91.586l2.256 4.962 5.91.455a1 1 0 0 1 .631 1.704L17.6 13.815l1.375 5.96a1 1 0 0 1-1.421 1.12L12 18.117l-5.553 2.776a1 1 0 0 1-1.421-1.119l1.375-5.96-4.108-4.108a1 1 0 0 1 .63-1.704l5.911-.455 2.256-4.962A1 1 0 0 1 12 2Zm0 3.417-1.59 3.497a1 1 0 0 1-.833.583l-4.332.333 2.962 2.963a1 1 0 0 1 .267.932l-1.022 4.431 4.1-2.05a1 1 0 0 1 .895 0l4.101 2.05-1.022-4.431a1 1 0 0 1 .267-.932l2.963-2.963-4.333-.333a1 1 0 0 1-.833-.583L12 5.417Z" fill="currentColor"/></svg>`,
};
